
import React from 'react';
import { Button } from '@/components/ui/button';
import { ProfileData } from '@/hooks/useProfiles';
import { ExperienceItem } from '@/hooks/profile';
import EmptyStatePublic from './EmptyStatePublic';
import TimelineExperienceItem from './experience/TimelineExperienceItem';

interface ExperienceTabProps {
  profile?: ProfileData;
  hideTitle?: boolean;
}

const ExperienceTab = ({ profile, hideTitle = false }: ExperienceTabProps) => {
  // Get the experience items and sort them chronologically (most recent first)
  const unsortedExperienceItems = profile?.experience_items || [];
  
  // Sort by start date in descending order (most recent first)
  const experienceItems = [...unsortedExperienceItems].sort((a, b) => {
    // Convert to date objects for comparison
    // Use end date if available, otherwise use start date
    // For current positions, they should be at the top
    if (a.current && !b.current) return -1;
    if (!a.current && b.current) return 1;
    
    const aDate = a.end_date || a.start_date || '';
    const bDate = b.end_date || b.start_date || '';
    
    return bDate.localeCompare(aDate);
  });
  
  return (
    <div className="space-y-8 pt-3 flex flex-col items-center">
      
      {!hideTitle && <h2 className="text-2xl font-bold mb-4 w-full max-w-3xl">Experience</h2>}
      
      {experienceItems.length > 0 ? (
        <div className="relative w-full max-w-3xl">
          {/* Timeline container with proper structure for connected timeline */}
          <div className="relative">
            {experienceItems.map((experience: ExperienceItem, index: number) => (
              <TimelineExperienceItem 
                key={`${experience.id}-${index}`}
                item={experience}
                index={index}
                isLast={index === experienceItems.length - 1}
              />
            ))}
          </div>
          
          {experienceItems.length > 5 && (
            <div className="flex justify-center mt-10">
              <Button variant="outline">Show more experience</Button>
            </div>
          )}
        </div>
      ) : (
        <EmptyStatePublic 
          type="experience" 
          username={profile?.username} 
          profileId={profile?.id}
          profile={profile}
        />
      )}
    </div>
  );
};

export default ExperienceTab;
